import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box
} from '@mui/material';
import styles from './OperatorCreateDialog.styles';
import {
  checkOperatorCodeExists,
  createOperatorWithCode,
} from '../../services/operator.api';
import ValidatedField from '../../../../components/inputs/ValidatedField';
import { OPERATOR_NAME_RULES, OPERATOR_CODE_RULES } from '../../utils/operatorValidation';

export default function OperatorCreateDialog({ open, onClose, onSubmit }) {
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [existsError, setExistsError] = useState(false);

  useEffect(() => {
    if (open) {
      setName('');
      setCode('');
      setExistsError(false);
    }
  }, [open]);

  const validName = OPERATOR_NAME_RULES.every((r) => r.test(name));
  const trimmed = code.trim().toUpperCase();
  const validCode = OPERATOR_CODE_RULES.every((r) => r.test(trimmed));
  const createDisabled = !validName || !validCode || loading || existsError;

  const handleSubmit = async () => {
    if (createDisabled) return;
    setLoading(true);

    try {
      const { exists } = await checkOperatorCodeExists(trimmed);
      if (exists) {
        setExistsError(true);
        setLoading(false);
        return;
      }

      const data = await createOperatorWithCode({
        Description: name.trim(),
        Code: trimmed,
      });

      onSubmit?.(data);
      onClose();
      window.location.reload();
    } catch (err) {
      alert('Failed to create operator: ' + (err?.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={styles.title}>Create New Operator</DialogTitle>

      <DialogContent sx={styles.content}>
        <Box sx={styles.section}>
          <Typography variant="subtitle2" sx={styles.label}>
            Operator Name
          </Typography>
          <ValidatedField
            placeholder="Enter operator name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            rules={OPERATOR_NAME_RULES}
            sx={styles.field}
          />

          <Typography variant="subtitle2" sx={styles.label}>
            Code
          </Typography>
          <ValidatedField
            placeholder="Enter operator code"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setExistsError(false);
            }}
            rules={OPERATOR_CODE_RULES}
            externalError={existsError ? 'That code is already in use' : ''}
            sx={styles.field}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} variant="contained" disabled={loading} sx={styles.btnSecondary}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={createDisabled}
          variant="contained"
          sx={styles.btnPrimary}
        >
          {loading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
